import { render, staticRenderFns } from "./message.vue?vue&type=template&id=209cb89c"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209cb89c')) {
      api.createRecord('209cb89c', component.options)
    } else {
      api.reload('209cb89c', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=209cb89c", function () {
      api.rerender('209cb89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/message.vue"
export default component.exports